import React, { FC } from 'react';
import { ReactComponent as Warning } from '../../../assets/Common/warning.svg';

export const WarningIcon: FC = () => <Warning />;
